export default __webpack_public_path__ + "static/199-bfaf7095712b7a491bb68443eccf65a3.jpg";